// Key items, bonus-game pieces and arcade props (docs/05 §plug parts, docs/06, docs/07 §1).
// 1-px ink outline, light from top-left. Key: '.' transparent, 'o' ink, other chars per sprite.
import { sprite, type SpriteDef } from './types';

export const ITEM_SPRITES: SpriteDef[] = [
  // Rusted Prong: a lone flat prong, rust climbing it from the snapped bakelite stub.
  sprite(
    'item_plug_1',
    {
      o: 'ink',
      h: 'paper',
      s: 'steel',
      l: 'lilacGrey',
      d: 'dusk',
      C: 'copper',
      R: 'rust',
      B: 'brick',
      M: 'maroon',
      b: 'bronze',
      K: 'lilacGrey',
      k: 'dusk',
      n: 'night',
      q: 'ink',
      G: 'steel',
    },
    [
      '........................',
      '........................',
      '.................o......',
      '................oho.....',
      '...............ohsso....',
      '..............oCssslo...',
      '.............oCRoolldo..',
      '............obRsooRMo...',
      '...........oCRRslBMo....',
      '..........ohCRbllMo.....',
      '.........oCssRBldo......',
      '........ohsCClldo.......',
      '.......obssCRldo........',
      '......ohsRRlldo.........',
      '.....oossRBldo..........',
      '..ooooKoRlldo...........',
      '.oKKKKnKoldo............',
      '.okGnnnnKoo.............',
      'oKnnnnnqoo..............',
      'oknnnnnnKo..............',
      'oknnKnnnnKo.............',
      'oknnnnnnnqo.............',
      '.okqqqqqqo..............',
      '..ooooooo...............',
    ],
  ),
  // Frayed Cord: a hank of old cloth cord, its end stripped to splayed copper.
  sprite(
    'item_plug_2',
    {
      o: 'ink',
      h: 'sand',
      m: 'mauveGrey',
      d: 'plumGrey',
      c: 'copper',
      b: 'bronze',
      y: 'brass',
    },
    [
      '........................',
      '.....................c..',
      '.................b...c..',
      '....ooooooo......b.y.c..',
      '...ohmhomhooooo...byc..b',
      '..ohmhomhomhhmho..byc.b.',
      '..omhomhomhhmhhmo..bcb..',
      '.omhomhhohhooommo.obco..',
      '.ohhohhohhoomdomdoocco..',
      '.ohmohmohmoodmodmoohdo..',
      'ohmohmoomhodomommoohdo..',
      'omhomhomhoddoddoddomdo..',
      'ohhohhohhoddoddoddohdo..',
      'ohdohmohmoddoddoddohdo..',
      '.omommommodooddoddomdo..',
      '.omdomdomdooddoddoohdo..',
      '.odmodmodmooddoddohmdo..',
      '..omommommodddodoohdo...',
      '..oddoddoddooodohmddo...',
      '...oddododddddohmddo....',
      '....oooododddddoooo.....',
      '........ooooooo.........',
      '........................',
      '........................',
    ],
  ),
  // Old Fuse: glass cartridge, brass caps, the filament long since blown.
  sprite(
    'item_plug_3',
    {
      o: 'ink',
      s: 'steel',
      w: 'white',
      L: 'lilacGrey',
      D: 'dusk',
      f: 'paper',
      n: 'night',
      a: 'amber',
      y: 'lemon',
      b: 'brass',
      z: 'bronze',
      c: 'copper',
    },
    [
      '.................o......',
      '................oyo.....',
      '...............oyybo....',
      '..............oyybbbo...',
      '.............obbbbbbzo..',
      '.............oyzzbbzzco.',
      '............osobzzzzccco',
      '...........osswobccccco.',
      '..........osswLfozccco..',
      '.........osswLfLLocco...',
      '........osswLffLDDoo....',
      '.......osswanLLDDo......',
      '.....oosswLnoLDDo.......',
      '....oyoswLfLLDDo........',
      '...obyboLffLDDo.........',
      '..oybzbboLLDDo..........',
      '.oyybzzbzoDDo...........',
      'oyybbbzczcoo............',
      '.obbbbzcccco............',
      '..obbzzccco.............',
      '...ozzccco..............',
      '....occco...............',
      '.....oco................',
      '......o.................',
    ],
  ),
  // Wall Switch: yellowed toggle plate, two screws, flipped UP.
  sprite(
    'item_plug_4',
    {
      o: 'ink',
      w: 'white',
      p: 'paper',
      P: 'khaki',
      k: 'sand',
      s: 'steel',
      l: 'lilacGrey',
      d: 'dusk',
      n: 'night',
      S: 'sand',
    },
    [
      '......oooooooooooo......',
      '.....owwwwwwwwwwwwo.....',
      '....owpppppPPpppppwo....',
      '....owppppPslkpppPko....',
      '....owppppPldkpppPko....',
      '....owpppppooppppPko....',
      '....owpSppowpopppPko....',
      '....owppppowpokppPko....',
      '....owpppkopkokppPko....',
      '....owpppkopkoPppPko....',
      '....owpppkokkoPpSPko....',
      '....owpppkooooPppPko....',
      '....owpSpkonnoPppPko....',
      '....owpppkonnoPppPdo....',
      '....owpppkooooPppdko....',
      '....owpppPPPPPPSpdko....',
      '....owppSpppppppdPko....',
      '....owpppppppppppPko....',
      '....owpppppPPppppPko....',
      '....owppppPslkpppPko....',
      '....owppppPldkpppPko....',
      '....owpPPPPkkPPPPPko....',
      '.....owkkkkkkkkkkko.....',
      '......oooooooooooo......',
    ],
  ),
  // The Plug: brown bakelite, two brass prongs, a short cloth cord.
  sprite(
    'item_plug_5',
    {
      o: 'ink',
      h: 'sand',
      m: 'mauveGrey',
      d: 'plumGrey',
      c: 'copper',
      y: 'lemon',
      b: 'brass',
      C: 'copper',
      B: 'brick',
      M: 'maroon',
      Z: 'bronze',
    },
    [
      '........................',
      '.......oo......oo.......',
      '......oybo....oybo......',
      '......oybo....oybo......',
      '......oybo....oybo......',
      '......oybo....oybo......',
      '......oybo....oybo......',
      '......oooooooooooo......',
      '.....oCCCCCCCCCCCCo.....',
      '....oCZCBBBBBBBBBBCo....',
      '....oCBBBBBBBBBBBBMo....',
      '....oCBMMMMMMMMMMBMo....',
      '....oCBBBBBBBBBBBBMo....',
      '....oCBMMMMMMMMMMBMoo...',
      '....oCBBBBBBBBBBBBMooo..',
      '....oCMMBBBBBBBBMMMocco.',
      '.....oooCBMBBBBMooohmdo.',
      '........oCMMMMMo..ohdo..',
      '.........oooooo...ohdo..',
      '.........ohmdo..oohmdo..',
      '..........ohdooohhmdo...',
      '..........ohdhhhdddo....',
      '...........oohddooo.....',
      '.............ooo........',
    ],
  ),
  // Ledger page: folded in quarters, blue-ink lowercase notes, a coffee ring.
  sprite(
    'item_ledger',
    {
      o: 'ink',
      w: 'white',
      p: 'paper',
      s: 'steel',
      l: 'lilacGrey',
      r: 'dustyPink',
      i: 'indigo',
      c: 'sand',
      C: 'mauveGrey',
    },
    [
      '........................',
      '....ooooooooooooo.......',
      '...owwwwwwwwspoloo......',
      '...owwrwwwwwsposloo.....',
      '...owwrwiiiwsiossloo....',
      '...owwrwwwwwsposssloo...',
      '...owwrwwwwwspolllllo...',
      '...owwrwiiwispioooooo...',
      '...owwrwwwwwspppppppo...',
      '...owwrwwiwwspipppipo...',
      '...owwrwiiiisiiipiipo...',
      '...owwrwwwwwspppppppo...',
      '...ossrsssssllllllllo...',
      '...opprppppplscccssso...',
      '...opprpiipilciiiisso...',
      '...opprpppppcsssssCso...',
      '...opprppippcissssCso...',
      '...opprpiiipciisiiCso...',
      '...opprppppplcsssCsso...',
      '...opprpppppliCCCssso...',
      '...opprpiiiplisssssso...',
      '...opppppppplssssssso...',
      '....oooooooooooooooo....',
      '........................',
    ],
  ),
  // Relic Shard: a splinter of something between crystal and bone, humming lilac.
  sprite(
    'item_shard',
    {
      o: 'ink',
      W: 'white',
      P: 'pinkLilac',
      L: 'lavender',
      V: 'violet',
      U: 'purple',
      g: 'purple',
    },
    [
      '............g...........',
      '...........goo.....P....',
      '..........goWUo...PWP...',
      '.........goWWLUo...P....',
      '....P...goWPWLLUo.......',
      '...PWP.goWPPWLLLUo......',
      '....P...oWPPWLLLUog.....',
      '.......goWPPWLLVUo......',
      '......goWPPPWLVVUog.....',
      '.......oWPPPWVVVUo......',
      '......goWPPPWVVVUog..L..',
      '.......oWPPPWVVVUo......',
      '......goWPPPWVVUo.......',
      '.......oWPPPVVVUog......',
      '......oWPPPPVVUog.......',
      '.....goWPPPPVVUo........',
      '......goWPPPVUo.....P...',
      '.......oWPPPVUog...PWP..',
      '........oWPPUog.....P...',
      '.........oWPUo..........',
      '.....P..goWPo...........',
      '.........goWog..........',
      '..........gog...........',
      '...........g............',
    ],
  ),
  // Tooth: the Teeth currency icon. A clean white molar.
  sprite('item_tooth', { o: 'ink', w: 'white', W: 'white', p: 'paper', s: 'steel', l: 'lilacGrey' }, [
    '........................',
    '........................',
    '........................',
    '.......ooo....ooo.......',
    '......oWWsooooWpso......',
    '.....oWwwWspsWpppso.....',
    '....oWWwWWWWppppppso....',
    '....oWWWWWWWppppppso....',
    '....oWWWWWWpppppppso....',
    '....oWWWWWppppppppso....',
    '....oWWWWppppppppsso....',
    '....oWWWppppppppsslo....',
    '....oWWppppppppssslo....',
    '....osppppppppssssso....',
    '.....opppppsssssslo.....',
    '.....oppsssoossssso.....',
    '.....opssssoosssso......',
    '......ossso..ossso......',
    '......ossso..ossso......',
    '......ossso..ossso......',
    '......osso....osso......',
    '.......oo......oo.......',
    '........................',
    '........................',
  ]),
  // Payphone handset: blue-black bakelite, armored cord. Dolores is calling.
  sprite(
    'item_phone',
    {
      o: 'ink',
      s: 'steel',
      l: 'lilacGrey',
      h: 'cobalt',
      i: 'indigo',
      n: 'navy',
      N: 'ink',
      g: 'brass',
    },
    [
      '........................',
      '.............oooo.......',
      '........g...ohhhho......',
      '.....g.....ohiiiiho.....',
      '......g...oohiiiiiho....',
      '...g....oohhiiiiinnho...',
      '....g..ohhiiiiiinnnnho..',
      '......ohisiiininnnnnnho.',
      '..g..ohisiinnohnnnnnnno.',
      '.....ohsiinoo.ohnnnnnNo.',
      '....ohiiino....ohnnnnN..',
      '...oohiino......ohnNN...',
      '..ohhiiino.......ooo....',
      '.ohiiiino...............',
      '.ohiiiiiho..............',
      '.ohiiiinnho.............',
      '.ohiiinnnnho....oooo....',
      '..ohinnnnnnho..oslsloo..',
      '...ohnnnnnnno.oslslslso.',
      '....ohnnnnnNooslooooslso',
      '.....ohnnnnNlslo....oolo',
      '......ohnNNlslo.......o.',
      '.......oooosoo..........',
      '...........o............',
    ],
  ),
  // Hi-Lo card back: wine velvet lattice, brass frame, a grinning brass mouth.
  sprite(
    'card_back',
    {
      o: 'ink',
      c: 'cream',
      w: 'wine',
      m: 'maroon',
      b: 'brass',
      z: 'bronze',
      y: 'lemon',
      Z: 'copper',
      k: 'ink',
      t: 'white',
      T: 'cream',
      g: 'gold',
    },
    [
      '..oooooooooooooooooooo..',
      '.occcccccccccccccccccco.',
      'occwwwwwwwwwwwwwwwwwwcco',
      'ocwbzbzbzbzbzbzbzbzbzwco',
      'ocwzwwmwwzwwmwwzwwmwbwco',
      'ocwbwgwmwwwmwmwwwmgmzwco',
      'ocwzmwwwmwmgbwmwmwwwbwco',
      'ocwbwwzwwmgbzzwmwwzwzwco',
      'ocwzmwwwmwmzZwmwmwwwbwco',
      'ocwbwmwmwwwmwmwwwmwmzwco',
      'ocwzwmmwwzwwmwwzwmmwbwco',
      'ocwbmoommmmmwmmmmoomzwco',
      'ocwzoyyoooommoooobbobwco',
      'ocwbokzyyyyoobbbbzkozwco',
      'ocwzobkTtzzybzztTkbobwco',
      'ocwbmobkktTttTtkkbomzwco',
      'ocwzwmobtkkkkkktbomwbwco',
      'ocwbwmoZbbTttTbbZommzwco',
      'ocwzmwmoZzbbbbzZomwwbwco',
      'ocwbwwzmoZZZZZZomwzwzwco',
      'ocwzmwwwmoooooommwwwbwco',
      'ocwbwmwmwmmmmmmwwmwmzwco',
      'ocwzwwmwwzwwmwwzwwmwbwco',
      'ocwbwmwmwwwmwmwwwmwmzwco',
      'ocwzmwwwmwmgbwmwmwwwbwco',
      'ocwbwwzwwmgbzzwmwwzwzwco',
      'ocwzmgwwmwmzZwmwmwgwbwco',
      'ocwbwmwmwwwmwmwwwmwmzwco',
      'ocwzbzbzbzbzbzbzbzbzbwco',
      'occwwwwwwwwwwwwwwwwwwcco',
      '.occcccccccccccccccccco.',
      '..oooooooooooooooooooo..',
    ],
  ),
  // Hi-Lo card face: blank cream stock, apricot border, eye pips. The rank is drawn on top.
  sprite('card_face', { o: 'ink', c: 'cream', w: 'white', a: 'apricot', r: 'blood', k: 'ink' }, [
    '..oooooooooooooooooooo..',
    '.owwwwwwwwwwwwwwwwwwwwo.',
    'owccccccccccccccccccccao',
    'owccaaaaaaaaaaaaaaaaccao',
    'owcaccccccccccccccccacao',
    'owcaccrrrcccccccccccacao',
    'owcacrwkwrccccccccccacao',
    'owcaccrrrcccccccccccacao',
    'owcaccccccccccccccccacao',
    'owcaccccccccccccccccacao',
    'owcaccccccccccccccccacao',
    'owcaccccccccccccccccacao',
    'owcaccccccccccccccccacao',
    'owcaccccccccccccccccacao',
    'owcaccccccccccccccccacao',
    'owcaccccccccccccccccacao',
    'owcaccccccccccccccccacao',
    'owcaccccccccccccccccacao',
    'owcaccccccccccccccccacao',
    'owcaccccccccccccccccacao',
    'owcaccccccccccccccccacao',
    'owcaccccccccccccccccacao',
    'owcaccccccccccccccccacao',
    'owcaccccccccccccccccacao',
    'owcacccccccccccrrrccacao',
    'owcaccccccccccrwkwrcacao',
    'owcacccccccccccrrrccacao',
    'owcaccccccccccccccccacao',
    'owccaaaaaaaaaaaaaaaaccao',
    'owccccccccccccccccccccao',
    '.oaaaaaaaaaaaaaaaaaaaao.',
    '..oooooooooooooooooooo..',
  ]),
  // Wheel of Fate pointer: a brass teardrop with a ruby rivet, pointing DOWN.
  sprite(
    'wheel_pointer',
    {
      o: 'ink',
      l: 'lemon',
      b: 'brass',
      z: 'bronze',
      c: 'copper',
      r: 'red',
      h: 'coral',
      d: 'blood',
    },
    [
      '...oooooo...',
      '..olllbbbo..',
      '.olllbbbbzo.',
      'olllboobzzzo',
      'ollbohrozzzo',
      'olbbordozzco',
      'obbbboozzcco',
      '.olbbbzzzco.',
      '.olbbbzzzco.',
      '..olbbzzco..',
      '..olbbzzco..',
      '...olbzco...',
      '...olbzco...',
      '....olco....',
      '....olco....',
      '.....oo.....',
    ],
  ),
  // Wheel of Fate hub: a brass boss that grins.
  sprite(
    'wheel_hub',
    {
      o: 'ink',
      l: 'lemon',
      b: 'brass',
      z: 'bronze',
      c: 'copper',
      w: 'white',
      k: 'maroon',
    },
    [
      '.....oooooo.....',
      '....ollbbbbo....',
      '...ollbbbbbbo...',
      '..ollbbbbbbzzo..',
      '.ollbbbbbbzzzzo.',
      'ollbbbbbbzzzzzzo',
      'olbbbbbbzzzzzzco',
      'obbbbbbzzzzzzcco',
      'obboobzzzzzoocco',
      'obbowwowwowwocco',
      'obbbokkkkkkoccco',
      '.obzzowowwoccco.',
      '..ozzzooooccco..',
      '...ozzzccccco...',
      '....ozccccco....',
      '.....oooooo.....',
    ],
  ),
  // Teeth Drop peg: a tiny white tooth.
  sprite('peg_tooth', { o: 'ink', w: 'white', p: 'paper', s: 'steel' }, [
    '.oo..oo.',
    'owwoowpo',
    'owwwwwpo',
    'owwwwppo',
    'owppppso',
    '.opssso.',
    '.osooso.',
    '..o..o..',
  ]),
  // Teeth Drop gold peg: a gold crown tooth.
  sprite('peg_gold', { o: 'ink', w: 'lemon', p: 'gold', s: 'amber' }, [
    '.oo..oo.',
    'owwoowpo',
    'owwwwwpo',
    'owwwwppo',
    'owppppso',
    '.opssso.',
    '.osooso.',
    '..o..o..',
  ]),
  // Teeth Drop ball: a loose eyeball.
  sprite(
    'ball_eye',
    {
      o: 'ink',
      w: 'white',
      p: 'paper',
      s: 'steel',
      b: 'blue',
      B: 'cobalt',
      k: 'ink',
      h: 'white',
      r: 'red',
    },
    ['..oooo..', '.owwwpo.', 'owwbbppo', 'owbkhBpo', 'owbkkBso', 'orpBBsso', '.opssso.', '..oooo..'],
  ),
  // Payphone: steel coin box, navy header, the handset on its hook. The number is on the flyer.
  sprite(
    'payphone',
    {
      o: 'ink',
      p: 'paper',
      s: 'steel',
      l: 'lilacGrey',
      d: 'dusk',
      P: 'steel',
      w: 'white',
      W: 'paper',
      D: 'dusk',
      r: 'red',
      n: 'navy',
      N: 'ink',
      i: 'indigo',
      c: 'cobalt',
      k: 'sky',
      y: 'gold',
      Y: 'amber',
    },
    [
      '................................',
      '.........ooooooooooooooooooooo..',
      '........occccccccccccccccccccco.',
      '........ocnnnnnnnnnnnnnnnnnnnNo.',
      '........ocnnkknkknkynkknkknnnNo.',
      '........ocnnnnnnnnnnnnnnnnnnnNo.',
      '........ocNNNNNNNNNNNNNNNNNNNNo.',
      '.........ooooooooooooooooooooo..',
      '.........opsoooooooossssssslpo..',
      '.........opowwwwwwwwossssssldo..',
      '....oo...opoWWWWWWWWoslooolldo..',
      '...occo.oopoWrrDDWDWosopppdldo..',
      '..ocincoplooWWWWWWWWosooooPldo..',
      '.ociinncolooWDDWDDDWosoddddldo..',
      '.ociinnNolooWWWWWWWWoslooolldo..',
      '.ociinnNolooWWDDDWWWossssssldo..',
      '.ociinnopoooWWWWWWWWossssssldo..',
      '.ociinNoloosoooooooosssssssodo..',
      '.ociinNoolossssssssssssssssldo..',
      '.ociinNoplosoooooooooooooooldo..',
      '.ociinNoploooooooooooooooooodo..',
      '.occinNoploooddddddddddddddodo..',
      '.occinNoplooodwpddwpddwpdddodo..',
      '.occinNooopoodllodllodlloddodo..',
      '.occinNo.opoodooddooddoodddodo..',
      '.ociinNo.opooddddddddddddddodo..',
      '.occinNo.opoodwpddwpddwpdddodo..',
      '.occinNo.opoodllodllodlloddodo..',
      '.occinNo.opoodooddooddoodddodo..',
      '.occinNo.opooddddddddddddddodo..',
      '.ociinNo.opoodwpddwpddwpdddodo..',
      '.occinNo.opoodllodllodlloddodo..',
      '.occinNo.opoodooddooddoodddodo..',
      '.occinNo.opooddddddddddddddodo..',
      '.occinNo.opoodwpddwpddwpdddodo..',
      '.ociinNo.opoodllodllodlloddodo..',
      '.occinNo.opoodooddooddoodddodo..',
      '.ociinNo.opsoooooooooooooooldo..',
      '.ociinNo.opssssssssssssssssldo..',
      '.ociinncoopssssssssssssssssldo..',
      '.ociinnNoopssssssssssssssssldo..',
      '.ociinnNoopssssssssssssssssldo..',
      '.ociinnNoopssssssssssssssssldo..',
      '..ocinNo.opssssooooooooosssldo..',
      '...ocNo..opsssolllllllllossldo..',
      '...oooo..opsssoopppppppoossldo..',
      '...olso..opsssoollllllloossldo..',
      '...oslo..opsssoNNNNNNNNNossldo..',
      '...osso..opsssoNNNyNNNNNossldo..',
      '...olso..opsssoNNNyYNNNNossldo..',
      '....olso.opsssodddddddddossldo..',
      '....oslo.opsssodddddddddossldo..',
      '....osso.opssssooooooooosssldo..',
      '....olssoopsoooooooooooooooldo..',
      '.....olsoopocccccccccccccccodo..',
      '.....oslsoponnnnnnnnnnnnnnnodo..',
      '......osloponnnnnnnnnnnnnnnodo..',
      '.......ooopooooooooooooooooodo..',
      '.........opllllllllllllllllldo..',
      '..........opddddddddddddddddo...',
      '...........ooooooooooooooooo....',
      '................................',
      '................................',
      '................................',
    ],
  ),
  // Missing-person flyer (DOLORES R.): photo, text, tear-off tabs, one taken. Pinned crooked.
  sprite(
    'flyer',
    {
      o: 'ink',
      w: 'white',
      p: 'paper',
      s: 'steel',
      k: 'ink',
      l: 'steel',
      b: 'lilacGrey',
      n: 'dusk',
      f: 'steel',
      F: 'paper',
      K: 'khaki',
      R: 'red',
      B: 'blood',
      h: 'coral',
    },
    [
      '............oo..........',
      '...ooooooooohRoooooooo..',
      '..owwwwwwwwoRBowwwwwwso.',
      '..owppppppppoopppppppso.',
      '..owpppppppppppppppppso.',
      '..owkkkpkpkkpkkpkpkkpko.',
      '..owkpkpkpkkpkkpkpkkpko.',
      '..owpppppppppppppppppso.',
      '.owpppppppppppppppppso..',
      '.owppppkkkkkkkkkppppso..',
      '.owppppkbbbbbbbkppppso..',
      '.owppppkbbnnnbbkppppso..',
      '.owppppkbnnffnbkppppso..',
      '.owppppkbnfFfnbkpKppso..',
      '.owppppkbnfffnbkpKKpso..',
      '.owppppkbbnfnbbkppKpso..',
      '.owppppkbnnnnnbkppppso..',
      '.owppppkkkkkkkkkppppso..',
      'owpppppppppppppppppso...',
      'owppkkkkkkkpkkkkkkpso...',
      'owpppppppppppppppppso...',
      'owplpllllpllllplllpso...',
      'owpppppppppppppKpppso...',
      'owppllllpllllppppppso...',
      'owpplpplpplpplpplppso...',
      '.opsopsoooopsopsopso....',
      '.olsolso..olsolsolso....',
      '.olsolso..olsolsolso....',
      'olsolso..olsolsolso.....',
      'opsopso..opsopsopso.....',
      '.oo.oo....oo.oo.oo......',
      '........................',
    ],
  ),
  // Wall clock: brass rim, cream face. It is always 3:33.
  sprite(
    'clock',
    {
      o: 'ink',
      y: 'lemon',
      b: 'brass',
      z: 'bronze',
      Z: 'copper',
      a: 'apricot',
      c: 'cream',
      k: 'ink',
      S: 'sand',
    },
    [
      '.........oooooo.........',
      '......oooyyybbbooo......',
      '.....oyyyyybbbbbbbo.....',
      '....oyyyyybZZbbbbbbo....',
      '...oyyyyZZaakaZZbbzzo...',
      '..oyyyZZaacckcacZZzzzo..',
      '.oyyyZaaSccccccSccZzzzo.',
      '.oyyyZacccccccccccZzzzo.',
      '.oyyZaSccccccccccScbzzo.',
      'oyyyZacccccccccccccbzzZo',
      'oyybaccccccccccccccczZZo',
      'oybZaccccccybcccccccbZZo',
      'obbZkkcccccbzkkkcckkbZZo',
      'obbbacccccckccckkcccZZZo',
      'obbbZaccccckcccccccbZZZo',
      '.obbZcSccckccccccScbZZo.',
      '.obbbZcccckcccccccbZZZo.',
      '.obbbZccSckccccSccbZZZo.',
      '..obzzZZckcckcccbbZZZo..',
      '...ozzzzbbcckcbbZZZZo...',
      '....ozzzzzzbbZZZZZZo....',
      '.....ozzzzZZZZZZZZo.....',
      '......oooZZZZZZooo......',
      '.........oooooo.........',
    ],
  ),
  // Arcade window at night: four panes of rain, a sill to catch it.
  sprite(
    'window_rain',
    {
      o: 'ink',
      f: 'dusk',
      F: 'plumGrey',
      L: 'lilacGrey',
      N: 'night',
      n: 'navy',
      i: 'indigo',
      c: 'cobalt',
      k: 'sky',
      m: 'mint',
      I: 'ice',
    },
    [
      '..oooooooooooooooooooooooooooooooooooooooooooo..',
      '.oLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLo.',
      '.oLFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFNo.',
      '.oLFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFNo.',
      '.oLFFooooooooooooooooooofooooooooooooooooooffNo.',
      '.oLFFonnnnnInnnnnnnnnnnofonnnnnnnnnnnnnnnnoffNo.',
      '.oLFFonnnnnknnnnnnnnnnnofonnnnnnnnnnnnnnnnoffNo.',
      '.oLFFonnnnknnnnnInnnnnnofonnnnnnnnnnnnnnnnoffNo.',
      '.oLFFonInnknnnnnknnnnnnofonnnnnnnnnnnmnnnnoffNo.',
      '.oLFFonknknnnnnknnnnnnkofoInnnnInnnnnmnnnnoffNo.',
      '.oLFFoknnnnnnnnnnnnnnnkofoknnnnknnnnnmnnnIoffNo.',
      '.oLFFoknnnnnnnnnnnnnnnnofonnnnkmnnnnnmnnnmoffNo.',
      '.oLFFonnnnnnnnnnnnnnnnnofonnnnmnnnnnnmnnmnoffNo.',
      '.oLFFonnnnnnnnnnnnnnnnnofomnnnmnnnnInmnnnnoffNo.',
      '.oLFFonnnnnnnnnnnInnnnnofomnnnnnnInmnmnnnnoffNo.',
      '.oLFFonnnnnnnnInnknnnnnofomnnnnnnkmnnInnnnoffNo.',
      '.oLFFonnnnnnnnknknnnnniofomnnnnnknnnnnnnnnoffNo.',
      '.oLFFonnnnnnnknnknnnnnnofomnnnnnknnnnnnnnnoffNo.',
      '.oLFFonnnnnnnnnknnnnninofomnnnnnnnnnnnnnnioffNo.',
      '.oLFFonnnnnnnnnInnnnninofomnnnnnnnnInnnnnIoffNo.',
      '.oLFFonnnnnIInnknnnnnniofomnnnnnnnnmnmnnnkoffNo.',
      '.oLFFonnnnnkknknnnnniniofomnnnnnnnmnnmnnknoffNo.',
      '.oLFFonnnnkknnknnnninnkofomnnnnnnnmnnmninnoffNo.',
      '.oLFFonnnnkknknnnnnnninofoInmnnnnmnnnmnnnioffNo.',
      '.oLFFonnnkknnInnnnininnofonnmnnnnnnnnmininoffNo.',
      '.oLFFonnnnnnnmnnnninnnnofonnmInnnnnnnIinnnoffNo.',
      '.oLFFonnnnnImnnnnnninInofonnmmnnnnnnnnniInoffNo.',
      '.oLFFonnnnnkmnnnnininknofonnmnnnnnnnninikIoffNo.',
      '.oLFFonnnnkmnnnninnnknnofonnmnInnnnnInnknkoffNo.',
      '.oLFFonnnInnnnnnnninnnnofonmmnknnnnnknikknoffNo.',
      '.oLFFooooooooooooooooooofooooooooooooooooooffNo.',
      '.oLFFffffffffffffffffffffffffffffffffffffffffNo.',
      '.oLFFooooooooooooooooooofooooooooooooooooooffNo.',
      '.oLFFonmnnnnnnnnnnknnnnofonnInnnnnknnnmnnnoffNo.',
      '.oLFFoimininininikininiofoinininikinimiminoffNo.',
      '.oLFFonmninininininininofoninIIiniminmnmnioffNo.',
      '.oLFFoimininininininmncofoinikmninmnmniminoffNo.',
      '.oLFFonmninininininimiiofonikmninimininmnioffNo.',
      '.oLFFoimininininininmniofoinkmininmniniminoffNo.',
      '.oLFFoimiiiiimiiiiiimciofoikiiiiiiIiiiimicoffNo.',
      '.oLFFoimiiiiimiiiiiimiiofoiiiIiiiiiiiiimcioffNo.',
      '.oLFFoimiiiiimiiiiiimicofoiiimiiiiiiiiimiioffNo.',
      '.oLFFoiIiiiiimiiiiicmciofoiimiiiiiiiiiiIicoffNo.',
      '.oLFFoiiiiiiimIiiiicmiiofoiiIiiiiiiiiiiciioffNo.',
      '.oLFFoiiiiiiimmiiiiimiiofoimkiiIiiiiiiiicioffNo.',
      '.oLFFoiiiiiiiIiiiicimiiofoikiiikiiiiiicicioffNo.',
      '.oLFFoiiiiiiimIiiciimiiofoiiiikiiiiiiciiiioffNo.',
      '.oLFFoiiiiiimikIiiicIiiofoiiiIkiiiiiiiiIiioffNo.',
      '.oLFFoiiiiiiikimciciiiiofoiiikiiiiiicickiioffNo.',
      '.oLFFoiiiiiiiimiciIiiiiofoiikiiiiiiicikiiioffNo.',
      '.oLFFoiiiiiiiimiickiiiiofoiikiiiiiiiickiiioffNo.',
      '.oLFFoiiiiiiiiicikiiiiiofoiiiiiiiiiciciiiioffNo.',
      '.oLFFoiiiiiiiiciikiiiiiofoiiiiiiiiciiiiiiioffNo.',
      '.oLFFoiIiiiiiiiikiiiiiiofoiiiiiiiiiicIiiiioffNo.',
      '.oLFFooooooooooooooooooofooooooooooooooooooffNo.',
      '.oLFFffffffffffffffffffffffffffffffffffffffffNo.',
      '.oooooooooooooooooooooooooooooooooooooooooooooo.',
      'oLLLLLLLLLLLkLLLLLLLLLLLLLLLLLLLLmLLLLLLLLLLLLLo',
      'oFFFFFFfFFFFFFfFFFFFFfFFFFFFfFFFFFFfFFFFFFfFFFFo',
      'offffffffffffffffffffffffffffffffffffffffffffffo',
      'offffffffffffffffffffffffffffffffffffffffffffffo',
      'oNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNo',
      'oNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNo',
      '.oooooooooooooooooooooooooooooooooooooooooooooo.',
    ],
  ),
  // A cabinet asleep under a tarp: velvet-dark folds, a tear, the base showing at the hem.
  sprite(
    'cabinet_tarp',
    {
      o: 'ink',
      P: 'plumGrey',
      d: 'dusk',
      n: 'night',
      a: 'aubergine',
      k: 'ink',
      m: 'mud',
      O: 'olive',
      M: 'moss',
    },
    [
      '................................................................',
      '................................................................',
      '................................................................',
      '..................ooooooooooooooooooooooooooo...................',
      '................oodPdddddddddddddddddddddddddoo.................',
      '..............ooPdPdPdPddddddddddddddddddddddddoo...............',
      '............oodPdPdddddddddddddddddddddddddddddddoo.............',
      '...........oPPPdPdPdPddddddddddddddddddddddddddddddo............',
      '..........odddnnaandddnnnnnnnnnnnnnnaaaaannnnakkaanno...........',
      '.........odddnnannddddnnnnnnnnnnnnnnnaaaannnnnakkaanno..........',
      '.........oddnnaanndddnnaannnnnnnnnnnnnaaaaannnaakkaano..........',
      '.........odnnaanndddnnaannnnnnnnnnnnnnnaaaannnnaakkaao..........',
      '.........onnaanndddnnaannnnnnnnnnnannnnnaakaannnaakkao..........',
      '.........onaanndddnnaannnnnnnnnnnaaannnnnaakannnnaakko..........',
      '.........oaaandddnnaaannnnnnanannnaaannnnaakkaannnakko..........',
      '.........oaanddddnaaannnnnnanannnnaaaannnnaakkannnnako..........',
      '.........oanndddnaaannnnnnaaannnanaaaaannnnakkkaannaao..........',
      '.........onndddnaaannddnnaaannnnnnnaaaaannnnakkkannnao..........',
      '.........ondddnaaannddnnaaannnnnananaaaaannnaakkkaanno..........',
      '.........odddnaaaanddnnaaannnnnanannnaaaaannnaakkkaano..........',
      '..........onaaaaaannnnaakakaaaaaaakkkkkaaaakkkkkkkkao...........',
      '..........onnaaaaannnaaaakaaaaaaaakkkkaaaaakkkkkkkako...........',
      '...........oaaaaaannnnaakakaaaaaaakkkkkaaaakkkkkkkko............',
      '...........odnnannddddnnaaanndddnaaaaanndnnaakkkanno............',
      '...........onnaannddddnnaaanndddnaaaaannddnnakkkaano............',
      '...........onnnandddddnnaaanndddnaaaaanndnnnakkkaano............',
      '...........onnanndddddnnaaanndddnnaakaannnnnakkkkano............',
      '...........onnnnndddddnnaannddddnnakkaannnnnaakkaano............',
      '...........onnnnndddddnnaaanndddnnakkaannnnnaakkkaao............',
      '...........onannddddddnaaannddddnnakkaannnnnakkkkaao............',
      '...........oaannndddddnaaaanndddnnakkaannnnnakkkkaao............',
      '...........onanndddddnnaaannddddnnakkaannnnnaakkkaao............',
      '...........onnnndddddnnaaaanndddnnaakaannnnnaakkkaao............',
      '...........onnnnddPddnnaaannddddnnaaaaannnnnnakkkaao............',
      '...........onnnndddddnnaaannddddnnaakaannnnnaakkkkao............',
      '...........onnnddddddnnaaannddddnnaaaaannnnnnakkkkao............',
      '...........onnnddddddnaaaannddddnnaakaannnnnaakkkkao............',
      '...........onnnddddddnnaaannddddnnaaaaannnnnnaakkkao............',
      '...........oannddddddnaaaannndddnnaakaannnnnnaakkkko............',
      '...........onnnddddddnnaaannddddnnaaaaannndnnaakkkko............',
      '...........onnndddddnnaaaannndddnnaakaannnnnnnakkkko............',
      '...........onndddddddnaaaannddddnnaaaaaannnnnnaakkko............',
      '...........oPPPPddddddddddddddddddddddddndndnddddddo............',
      '..........oPPPPddddddddddddddddddddddddddndnddddddddo...........',
      '.........oPPPPddddddddddddddddddddddddddndndnddddddddo..........',
      '........oPPPPPPddddddddddddddddddddddddddndnddddddddddo.........',
      '......oodPPPPPddddddddddddddddddddddddddndndnddddddddddoo.......',
      '.....odddndndnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnanaaaaaaaao......',
      '.....oddndnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnananaaaaaaaaao......',
      '.....odddndndnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnanaaaaaaaao......',
      '.....oddndnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnananaaaaaaaaao......',
      '.....odddndndnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnanaaaaaaaao......',
      '.....onaaaaaaaaaaaaaaaaaaaaakakakkkkkkkkkkkkkkkkkkkkkkkkko......',
      '......oaaaaaaaaaaaaaaaaaaaaaaaakakakkkkkkkkkkkkkkkkkkkkko.......',
      '.......oaaaaaaaaaaaaaaaaaaaakakakkkkkkkkkkkkkkkkkkkkkkko........',
      '........oaaaaaaaaaaaaaaaaaaaaaakakakkkkkkkkkkkkkkkkkkko.........',
      '........oaaaaaaaaaaaaaaaaaaakakakkkkkkkkkkkkkkkkkkkkkko.........',
      '.........oaanddPdnnaanddddnaaandddnakkanddnakkkandnaoo..........',
      '.........oaanddPdnaaanddddaakandddnakkanddnakkkandnno...........',
      '.........oaandPPdnaaandddnaakandddnakkanddnakkkannnno...........',
      '.........oaandPPdnaaandddnakkandddnakkanddnakkkannnno...........',
      '.........oaandPPdnaaandddnakkandddnakkanddnakkkanndnao..........',
      '.........oanndPPdnaaandddnaakandddnakkanddnakkkandnnao..........',
      '........oaanddPPdnaanndddnakaandddnakkanddnakkkanddnao..........',
      '........oaandPPdnnaanddddnaaaandddnakkandknakkkanddnao..........',
      '........oanndPPdnaaanddddnakaandddnakkandkkkakkanndnao..........',
      '........oanddPPdnaaanddddnakaandddnakkanddkOkkdanndnao..........',
      '........oandPPPdnaaandPddnakaanddnnakkanddkOMkkanndnno..........',
      '........oandPPddnaaanddddnakanndddaakkanddkMkkkkandnao..........',
      '........oandPPPdnaaandPddaakandddnnkkkanddnkkkkkandnno..........',
      '........onndPPddaaanndddnakkandddnaakkanddnnkkkkannnno..........',
      '........onddPPdnaaanddPdnaakandddnaakkanddnadkkkandnno..........',
      '........onddPPdnaaanddddnakkandddnaakkanddnnkkkkannnno..........',
      '........onddPddnaaanddddnaakandddnaakkanddnnakkkandnnao.........',
      '........ondPPddnaaanddddnakaandddnaakkanddnnakkkannnnao.........',
      '.......oandPPddaaaanddddnaaaandddnakkkandddnakkkandnnao.........',
      '.......oandPPdnaaaanddddnakaandddnaakkandddnakkkanndnao.........',
      '.......onndPPdnaaannddddnaaaandddnakkkandddnakkkannnnao.........',
      '.......onddPddnaaanddPddnakaandddnakkkandddnakkkannnnao.........',
      '.......ondPPPdnaaanddPddnaaanndddnakkkandddnakkkannnnao.........',
      '.......onddPddnaaanddPdnaakanndddnaakkandddnakkkannnnno.........',
      '.......ondPPPdnaaanddddnaaaanndddnakkkandddnakkkaannnno.........',
      '.......ondPPdnaaaanddddnaakanndddnakkkannddnakkkkannnno.........',
      '.......oddPPdnaaaanddddnakkanndddnakkkandddnakkkkannnno.........',
      '.......oddPPdnaaaanddddnakkaandddnakkkannddnakkkkannnno.........',
      '.......oddPddnaaaanddddnakkadddddnakkknnnddnakkkkannnnao........',
      '.......oddPddnakkadooodnakknooddnnakooonnddnnookkannndno........',
      '......onddPdodakanokkodnakkokkoddnnokkonndddokkokanndoo.........',
      '......ondddoookkkokkkkodnkokkkkoddokkkkodddokkkkonndo...........',
      '......onddo.omoookkkkkkoookkkkkkookkkkkkoookkkkkkooo............',
      '......ondo..ommkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkko............',
      '......oddo..ommkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkko............',
      '.......oo...ommkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkko............',
      '............ommkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkko............',
      '.............oooooooooooooooooooooooooooooooooooooo.............',
      '................................................................',
    ],
  ),
  // A hollow sibling: tarnished to olive and mud, face dead, glass cracked, its tray a gaping mouth.
  sprite(
    'cabinet_hollow',
    {
      o: 'ink',
      M: 'moss',
      O: 'olive',
      D: 'mud',
      g: 'sage',
      K: 'khaki',
      S: 'sand',
      a: 'aubergine',
      m: 'mulberry',
      k: 'ink',
      n: 'night',
      c: 'charcoal',
      d: 'dusk',
      l: 'lilacGrey',
      s: 'steel',
      p: 'paper',
      w: 'steel',
      G: 'mulberry',
    },
    [
      '................................................................',
      '................................................................',
      '.......................oooooooooooooooooo.......................',
      '....................oooKSKMKSKMKMKKMMOKSSooo....................',
      '.................oooMMKOOOOOOOOdlOOOOOOOOSOOooo.................',
      '................oOOMOOOODDdlDDDDDOOgdlDODOOOKSKo................',
      '..............ooKOOODooODDDDDDDDDOODODDOOooOOOOMoo..............',
      '.............oKSODDDDDOOODooooooooooooDDODDDDDDOKKo.............',
      '............oMOODdlDDDooooaaaaaaaaaaaaooooDDDdlDOOSo............',
      '............oMODDOOoooaaaaaaaaaaaaaaaaaaaaoooDOOODOo............',
      '...........oSOdlDDoaaaaaaaaaaaaaaaaaaaaaaaaaaoOgdlDKo...........',
      '...........oMODDDoaaaamamamammaammmammmaamaaaaoODgDOo...........',
      '...........oOOODOoaaaaaaaaaaaaaaaaaaaaaaaaaaaaaOODDco...........',
      '...........oOOODOoaaaaaaaaaaaaaaaaaaaaaaaaaaaaaOOODco...........',
      '...........oOODOOokkkkkkkkkkkkkkkkkkkkkkkkkkkkkOOODco...........',
      '...........oOOggOokkkkkkkkkkkkkkkkkkkkkkkkkkkkkOODDco...........',
      '...........oOODDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDco...........',
      '......oooooooooooooooooooooooooooooooooooooooooooooooooooo......',
      '.....oOOOMMMMMMOOOOOOOOMMMMMMOOOMMMMMMMMMMMMOOOOOMMMwMwMMwo.....',
      '.....oOOOODDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDwOwOwo.....',
      '.....oOOKODooooooooooooooooooooooooooooooooooooooooowMwKwwo.....',
      '.....oMOODDoakakakakakakakakakakakakakakakakakakakakowOwDco.....',
      '.....oMOODDokkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkoMwDwco.....',
      '.....oMOODDoakakakakakakakakakakakakakakakakakakakakowDwDco.....',
      '.....oMOODDokkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkoMODwco.....',
      '.....oOOODDoakakakakakakakakakakakakakakakakakakakakoMDDDco.....',
      '.....oMOOODokkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkoMODDco.....',
      '.....oMOOODoakakakakakakakakakakakakakakakakakakakakoMODDcooo...',
      '.....oMOOODokkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkoMODDcoDo...',
      '.....oMOOODoakakakakakakakakakakakakakakakakakakakakoMDDDcoDo...',
      '.....oOOOODokkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkoMDDDcoDo...',
      '.....oMOODDoakakakakakakakakakakakakakakakakakakakakoMODDcoDo...',
      '.....oMOODDokkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkoMDDDcoDo...',
      '.....oMOODDooooooooooooooooooooooooooooooooooooooooooMDDDcoDo...',
      '.....oMOODMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMDDDcoDo...',
      '.....oMOODDDggggODDDDDOOOODDDDDDDDOOODDODDggOOOgDDDDDDDDDcoDo...',
      '.....oMOODDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDMDDDcoDo...',
      '.....oMOOODooooooooooooooooooooooooooooooooooooooooooMDDDcoDo...',
      '.....oMOOODokkkkkkkkkkkkkkkkkkkkkkkkkkkkkklkkkkkkkkkoMDDDcoDo...',
      '.....oMOOODoknnnnnnnnnllkkknnnlnnnnlnkkkklnnnnnnnnnkoMDDDcoooo..',
      '.....oOOODDoknkkkkkkkkkkllknkkklkkklkkkllnkkkkkkkkkkoMDDDcoMMMo.',
      '.....oMOOODoknkkkkkkkkkkkklnkkkkskkskkskknklkkkkkkkkoMDDDcoOOco.',
      '.....oMOOODoknnccccccnckkkkllccccscscskllllcllllcnckoMODDcoOOco.',
      '.....oMOOODoknccccccncckkkknclllssssssskknccccccncckoMODDcoOOco.',
      '.....oMOOODokncccccnccckkkkncccmcmsppkkkkncccccnccckoMODDcoDDco.',
      '.....oMOODDoknccccncccckkkknccccncspskkkknccccncccckoMDDDcooDco.',
      '.....oMOODDokncccnccccckkkkncGGncsGscookkncccnccccckoMDDDcoDDco.',
      '.....oMOODDoknccncccccckkkknGGGGcGGscosklnccncccccckoMDDDcoDDco.',
      '.....oMOODDokncnccccccnkkkkncGGcsGGlnkkkklclccccccnkoMDDDcoDDco.',
      '.....oMOOODoknnccccccnckkkknnlclccGlckkkknnlcccccnckoMDDDcoDDco.',
      '.....oOOODDoknccccccncckkkknccccccnclkkkkncclclcncckoMDDDcoccco.',
      '.....oOOOODokncccccnccckkkkncccccncclkkkkncccccnccckoMODDcoooo..',
      '.....oOOOODoknccccncccckkkknccccncccclkkknccccncccckoMODDco.....',
      '.....oOOOODokncccnccccckkkkncccnccccckkkkncccnccccckoMODDco.....',
      '.....oMOOODoknnnnnnnnnnkkkknnnnnnnnnnkkkknnnnnnnnnnkoMODDco.....',
      '.....oMOODDokkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkoMODDco.....',
      '.....oMOODDooooooooooooooooooooooooooooooooooooooooooMDDDco.....',
      '.....oMOODMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMDDDco.....',
      '...oooooooooooooooooooooooooooooooooooooooooooooooooooooooooo...',
      '..oSKKSKSSKSSSSSKSSSSSKKKSSSSSSSSKSSKSSSSSKKSSSSKKKKSKKSSKKSSo..',
      '..oMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMo..',
      '..oOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOo..',
      '..oDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDo..',
      '...oooooooooooooooooooooooooooooooooooooooooooooooooooooooooo...',
      '.....oMOOOOOooooooDDooooooDDooooooDDDDgOOoooooooDDDOOODDDco.....',
      '.....oMOOOOOoamaaoDDoamaaoDDoamaaoDDDDgOOoDDDDDoDggODDDDDco.....',
      '.....oMOODOOoaaanoDDoaaanoDDoaaanoDDOggOOoDooocoOOOOOODDDco.....',
      '.....oOOODDDooooooODooooooODooooooOODggOOoDDDDDoDDOODDODDco.....',
      '.....oOOODDDDDDDOOODDDDOOOODDOODDDOODDDOOoooooooDDDODDODDco.....',
      '.....oMOODooooooooooooooooooooooooooooooooooooooooooooDDDco.....',
      '.....oMOOommmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmoDDco.....',
      '.....oMOOomaaaaaaaamaaaaaaaamaaaaaaaamaaaaaaaamaaaaaaaoDDco.....',
      '.....oMOOoaaaaaaaamaaaaaaaamaaaaaaaamaaaaaaaamaaaaaaaaoDDco.....',
      '.....oMOOoaaaaaaamaaaaaaaamaaaaaaaamaaaaaaaamaaaaaaaamoDDco.....',
      '.....oMOOoaaaaaamaaaaaaaamaaaaaaaamaaaaaaaamaaaaaaaamaoDDco.....',
      '.....oMOOOooooooooooooooooooooooooooooooooooooooooooooDDDco.....',
      '.....oMOOOOOOOODODooooooooooKSoooooKSoooooooooOOOOODDDDDDco.....',
      '.....oOOOOOODDDOoooooKSoookkKkkkkkkSkkKSooooooooDOOOOODDDco.....',
      '.....oOOOOOODDooooKSkSkkkkkkkkkkkkkkkkKkkkkkoKSoooOOOODDDco.....',
      '.....oMOOODOOooookKkkkkkkkkkkkkkkkkkkkkkkkkkkSkooooODDDDDco.....',
      '.....oMOOODDgoookkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkoooODDODDco.....',
      '.....oMOOODDDDOokkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkoDOODDODDco.....',
      '.....oMOOODODODoonnnkkkkkkkkkkkkkkkkkkkkkkkknnnooODODDODDco.....',
      '.....oMOOODODODDDooonnnkkkkkkkkkkkkkkkkkknnnoooggODODDODDco.....',
      '.....oMOKDDcDDDDDDDDooSKoonnnnkkkknnnnooSKooDDDDDDDDDDDoDco.....',
      '.....oMOODDDDDDDDDDDDDDDDDooooSKoSSoooDDDDDDDDDDDDDDDDDDDco.....',
      '...oooooooooooooooooooooooooooooooooooooooooooooooooooooooooo...',
      '..oMMKMKSSMMSSMKKMKKMMKMKSMMMSKMSSKOSSSKMMKOOKKOOOOSSSKSMSKOKo..',
      '..oMOOODDDDDOODDDDDDDDDDDDDOODDDDDDODDDDDDODOOOOOOOOOODDDOODco..',
      '..oMDDDDDDDDOODDDOODDDDDDOODDDDDDDDDDDDDDDOODDDDDOgOOOOODDDDco..',
      '..oMDDDDDDDDOODDDDDODDDDODODDDDDDDDDDDDOOODDDDDDDOgDDDOOODDDco..',
      '..oMDDDDDDDDOODDDDDODDDDDOODDDDDDDDDDDDDDDDDDDDDDOOOOOOOODDDco..',
      '..oMDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDco..',
      '..oMccccccccccccccccccccccccccccccccccccccccccccccccccccccccco..',
      '...oooooooooooooooooooooooooooooooooooooooooooooooooooooooooo...',
      '................................................................',
    ],
  ),
];
